<template>
  <b-card>
    <div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        v-b-modal.modal-lg
        variant="primary"
        block
        @click="show = true"
      >
        Manuel Tüketim Girişi
      </b-button>

      <b-modal
        v-model="show"
        title="Tüketim Verileri Değerleri"
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant"
        :body-bg-variant="bodyBgVariant"
        :body-text-variant="bodyTextVariant"
        :footer-bg-variant="footerBgVariant"
        :footer-text-variant="footerTextVariant"
      >
        <b-container fluid>
          <b-row class="mb-1 text-center">
            <b-col cols="3" />
            <b-col>İlk Endeks</b-col>
            <b-col>Son Endeks</b-col>
            <b-col>Tüketim</b-col>

          </b-row>

          <b-row class="mb-1">
            <b-col cols="3">
              Aktif Enerji
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mb-1">
            <b-col cols="3">
              Gündüz
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>

            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>

            </b-col>
          </b-row>

          <b-row>
            <b-col cols="3">
              Gece
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              İndüktüf Kapasitif
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-for="item-name"
              >
                <b-form-input
                  id="item-name"
                  type="text"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>

        <template #modal-footer>
          <div class="w-100">

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              size="sm"
              class="float-right"
              @click="show = false"
            >
              Tamam
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import {
  BButton, BModal, VBModal, BContainer, BRow, BCol, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BCol,
    BContainer,
    BModal,
    BRow,
    BFormGroup,
    BFormInput,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data: () => ({
    bodyBgVariant: 'light',
    bodyTextVariant: 'dark',
    footerBgVariant: 'warning',
    footerTextVariant: 'dark',
    headerBgVariant: 'info',
    headerTextVariant: 'light',
    show: false,
    variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
  }),
}
</script>
